import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeSalesOrderCreate } from './serialize';

/**
 * 獨立建立銷貨單（無客訂；結果永遠 DRAFT）。
 * POST `/crm/sales-order` — **pending backend**（前端 stub）。
 *
 * @param {object} payload full DRAFT＋customerId
 */
export async function createSalesOrder(payload) {
  const { data: raw } = await request.post(
    '/crm/sales-order',
    serializeSalesOrderCreate(payload),
  );
  return parseVer4DetailResponse(raw);
}
